module.exports = __webpack_public_path__ + "media/img/payments/seamless-6ed3e8b3fef73deb5cd62dd0e5148e9b.jpg";